/**
* Created by lobin on 2020/6/18.
*/
<template>
  <a-row :gutter="16">
    <a-col :span="5">
      <a-card :body-style="{padding: '16px 10px'}" :bordered="false" class="cabinet">
        <station-select @select="stationSelect" />
      </a-card>
    </a-col>
    <a-col :span="19">
      <a-card :body-style="{padding: '24px', minHieght: '600px'}" :bordered="false" class="cabinet">
        <div v-if="stationId">
          <a-row :gutter="16">
            <div style="text-align: right">
              <h3 style="float: left">取件投递热力图</h3>
              <a-space>
                <a-range-picker v-model="range" @change="dateChange" valueFormat="YYYY-MM-DD" />
              </a-space>
            </div>
            <a-divider />
            <a-col :span="24" class="chart">
              <!-- <h4>月报数据</h4> -->
              <a-spin :spinning="listloading" :delay="300">
                <e-chart :option="options" style="height: 420px;"></e-chart>
              </a-spin>
            </a-col>
          </a-row>
        </div>
        <a-empty v-else description="请选择站点" />
      </a-card>
    </a-col>

  </a-row>
</template>

<script type="text/babel">
import { mapActions } from 'vuex';
import { getHotPort } from '@/api/analysis';
import moment from 'moment';
import VChart from 'vue-echarts';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { ScatterChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import {
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  BrushComponent,
  MarkLineComponent,
  MarkAreaComponent,
  MarkPointComponent,
} from 'echarts/components';
import { downloadUrl } from '../../utils';

use([
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  BrushComponent,
  MarkLineComponent,
  MarkAreaComponent,
  MarkPointComponent,
  ScatterChart,
  CanvasRenderer,
  UniversalTransition,
]);
export default {
  components: {
    EChart: VChart,
  },
  data() {
    return {
      listloading: false,
      stationId: '',
      height: 280,
      style: { stroke: '#fff', lineWidth: 1 },
      dateRange: [],
      range: [
        moment().subtract(1, 'day').format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
      ],
      options: {
        // grid: {
        //   left: '3%',
        //   right: '7%',
        //   bottom: '7%',
        //   containLabel: true
        // },

        tooltip: {
          // trigger: 'axis',
          showDelay: 0,
          formatter(params) {
            if (params.value.length > 1) {
              return (
                `${params.seriesName
                } :<br/>${
                  params.value[0]
                }分 ${
                  params.value[1]
                }件 `
              );
            }
            return (
              `${params.seriesName
              } :<br/>${
                params.name
              } : ${
                params.value
              }件 `
            );
          },
          axisPointer: {
            show: true,
            type: 'cross',
            lineStyle: {
              type: 'dashed',
              width: 1,
            },
          },
        },
        legend: {
          data: ['取件', '投递'],
          left: 'center',
          bottom: 10,
        },
        xAxis: [
          {
            type: 'value',
            scale: true,
            axisLabel: {
              formatter: '{value}',
            },
            splitLine: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            scale: true,
            axisLabel: {
              formatter: '{value}',
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '取件',
            type: 'scatter',
            emphasis: {
              focus: 'series',
            },
            // prettier-ignore
            data: [],
            markPoint: {
              data: [
                { type: 'max', name: 'Max' },
              ],
            },
          },
          {
            name: '投递',
            type: 'scatter',
            emphasis: {
              focus: 'series',
            },
            // prettier-ignore
            data: [],
            markPoint: {
              data: [
                { type: 'max', name: 'Max' },
              ],
            },
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions(['getStationList']),
    handleChange(val) {
      this.year = val;
      this.getList();
    },
    stationSelect(stationId) {
      this.stationId = stationId;
      this.getList();
    },
    dateChange() {
      this.getList();
    },
    async getList() {
      this.listloading = true;
      const { stationId } = this;
      const { year } = this;
      const { data } = await getHotPort({
        id: stationId,
        start: this.range[0],
        end: this.range[1],
      });
      this.setDate(data);
      this.listloading = false;
    },
    setDate(sourceData) {
      this.options.series[0].data = sourceData.pick;
      this.options.series[1].data = sourceData.delivery;
      console.log(this.options);
    },
  },
};

</script>

<style lang="less" rel="stylesheet/less">
.cabinet {
  .ant-avatar{
    font-size: 20px;
  }
  &-item{
    .ant-avatar{
      background: rgba(0,0,0,.09);
    }
    &.processing{
        .ant-avatar{
          background: rgb(135, 208, 104);
        }
    }
    .warning{
      .ant-avatar{
        background: #faad14;
      }
    }
    &.error{
      .ant-avatar{
        background: #f5222d;
      }
    }
  }
}
.list-content-item {
  color: rgba(0, 0, 0, .45);
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  margin-left: 40px;
  span {
    line-height: 20px;
  }
  p {
    margin-top: 4px;
    margin-bottom: 0;
    line-height: 22px;
  }
}
</style>
